var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHmCenterShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 672.769,
    height: 251,
    viewBox: "0 0 672.769 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 4213"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.3668 8.24645C76.9875 3.32529 81.5835 0 86.7647 0H660.762C668.659 0 674.403 7.49667 672.349 15.122L611.185 242.122C609.774 247.36 605.023 251 599.598 251H12.0091C3.83664 251 -1.94511 243.009 0.611188 235.246L75.3668 8.24645Z",
    fill: "#FFE743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3668 8.24645C76.9875 3.32529 81.5835 0 86.7647 0H660.762C668.659 0 674.403 7.49667 672.349 15.122L611.185 242.122C609.774 247.36 605.023 251 599.598 251H12.0091C3.83664 251 -1.94511 243.009 0.611188 235.246L75.3668 8.24645Z",
    fill: "url(#paint0_linear_0_325)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_325",
    x1: 335.923,
    y1: 0,
    x2: 335.923,
    y2: 251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44279,
    stopColor: "#101010",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986949,
    stopColor: "#17171B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmCenterShape);
export default __webpack_public_path__ + "static/media/hmCenterShape.0ad0a1b20ceb5b81a20d22b0ea6401fc.svg";
export { ForwardRef as ReactComponent };